import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { generateTranslationSchema } from '@/shared/lib/generateTranslationSchema'
import { defaultTranslationsEdit } from '@/entities/ContentTranslation/lib/translationDefaults'
import { LanguageTabConfig } from '@/features/MultilingualTabs/model/types'
import { EditWebinarFormState } from '../model/types'

export const editWebinarFormDefault: EditWebinarFormState = {
  id: 0,
  translations: defaultTranslationsEdit,
  video_url: '',
  release_date: null,
  has_ai_translation: false,
  thumbnail: null,
}

export const editWebinarFormSchema = (t: TFunction, languageTabs: LanguageTabConfig[]) => {
  return Yup.object().shape({
    release_date: Yup.date().nullable(),
    video_url: Yup.string()
      .max(255, t('common:validation_messages.max', { count: 225 }))
      .required(t('common:validation_messages.required')),
    ...generateTranslationSchema(languageTabs, t, true).fields,
  })
}
